import { imageSuportService } from './ImageSuport'

export const filesService = {
  handle,
  handleBlob,
  handleImage,
  loadFile
}

function handle (data) {
  return new Promise(async (resolve) => {
    let files = []
    for (let file of data.target.files) {
      files.push(await loadFile(file))
    }
    resolve(files)
  })
}

function handleBlob (data, mymeType) {
  return new Promise(async (resolve) => {
    const file = await loadFile(data.target.files[0])
    const blob = new Blob([file], {type: mymeType})
    resolve(blob)
  })
}

function handleImage (event) {
  return new Promise((resolve) => {
    let files = []
    for (let file of event.target.files) {
      files.push(imageSuportService.resizeImage(
        file,
        {
          canvasId: 'canvasPlace',
          maxWidth: 1366,
          maxHeight: 768,
          maxQuality: ''
        }
      ))
    }
    resolve(Promise.all(files))
  })
}

function loadFile (file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader()
    reader.onload = function (e) {
      resolve(e.target.result)
    }
    reader.onerror = function (e) {
      reject(e)
    }
    reader.readAsArrayBuffer(file)
  })
}



// WEBPACK FOOTER //
// ./src/services/filesService.js